<template>
  <BootstrapVueTable
    :title="title"
    :subtitle="subtitle"
    :items="table_data"
    :fields="table_fields" />
</template>

<script>
import axios from 'axios'
import errorRoutingMixin from '@/mixins/errorRoutingMixin'
import data_formats from '@/utils/data_formats'
import BootstrapVueTable from '@/components/BootstrapVueTable'

export default {
  name: 'Autofunding',
  components: {BootstrapVueTable},
  mixins: [errorRoutingMixin],
  props: ['reference_entity', 'reference_year', 'reference_month'],
  data () {
    return {
      title: "Autofinancement des projets",
      subtitle: "Cette table présente les autofinancements mensuels définis par la comptabilité. Les montants indiquent la consommation théorique du budget autofin du projet en question.",
      raw_data: [],
      table_data: [],
      table_fields: [],
    }
  },
  watch: {
    all_props () {
      this.load_server_data()
    }
  },
  created () {
    this.load_server_data()
  },
  computed: {
    all_props () {
      return [
        this.reference_entity,
        this.reference_year,
        this.reference_month  
      ]
    },
  },
  methods: {
    load_server_data () {
      if (! this.reference_entity) return  // If user is not yet authenticated. do nothing
      let url = 'webapi/autofunding?entity=' + this.reference_entity + '&year=' + this.reference_year + '&month=' + this.reference_month 
      axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('jwt_access')}})
        .then(response => this.raw_data = response.data)
        .then(_ => this.build_table_data())
        .catch(error => {
          console.log(error)
          this.$router.push(this.routeOnError(error.response.status))
        })
    },

    build_table_data() {
      this.table_data = data_formats.col_to_row_format(this.raw_data)

      let sortable = {sortable: true}
      let number_format = {formatter: data_formats.number_format_frch_rounded, class: 'text-right', ...sortable}
      let months = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
      this.table_fields = [{key: 'IDPROJECTHESSO', label: 'No.', ...sortable},
                           {key: 'PROJECTMANAGERINITIAL', label: 'Resp.', ...sortable},
                           {key: 'PROJECTACRONYM', label: 'Acronyme', ...sortable},
                           {key: 'PreviousYear', label: 'Années préc.', ...number_format}]
                          .concat(months.map(m => ({key: m, label: m, ...number_format})))
                          .concat([{key: 'EndOfYear', label: 'Total fin année', ...number_format}])
    },
  }
}
</script>